import React, { Fragment, useContext, useState, useEffect } from "react";
import { Context } from "../store/AppContext";
import { Link, useNavigate } from "react-router-dom";
import "../../styles/Navbar.css";
import { FiChevronRight, FiChevronLeft } from "react-icons/fi";

const Navbar = () => {
	const { store, actions } = useContext(Context);
	const [paginaActual, setDPaginaActual] = useState("/"); //Marca la página actual en la navbar
	const history = useNavigate();

	const HandlerWitch = (event) => {
		actions.setWitch();
	};

	const HandlerCerrarSesion = async (event) => {
		const result = await actions.logoutFirebase();
		if (result.success) {
			// Redirigir al login
			window.location.href = "/";
		} else {
			console.error("Error al cerrar sesión:", result.error);
			// Aún así redirigir
			window.location.href = "/";
		}
	};

	const HandlerIdentificarPaginaActual = (event) => {
		setDPaginaActual(event.target.pathname);
		actions.setPaginaActual(event.target.pathname);
	};

	useEffect(() => {
		if (store.paginaActual != null) {
			setDPaginaActual(store.paginaActual);
		}
	}, []);

	const NavbarInicio = () => {
		return (
			<div
				className='off-canvas position-left reveal-for-medium no-print secondary navbar-sidebar'
				data-off-canvas
				data-position='left'
			>
				<div className='row column navbar-guest'>
					<br className='no-print' />
					<h5>DeNegocios.cl</h5>
					<br className='no-print' />
					<ul className='vertical menu no-print'>
						<li className='no-print'>
							<Link to='/'>Inicio</Link>
						</li>
					</ul>
				</div>
			</div>
		);
	};

	const NavbarDesplegado = () => {
		return (
			<div
				className='off-canvas position-left reveal-for-medium no-print secondary navbar-sidebar'
				data-off-canvas
				data-position='left'
			>
				<div className='navbar-header'>
					<div className='navbar-brand'>
						<h5>DeNegocios.cl</h5>
						<button className='btn-toggle-navbar' onClick={(e) => HandlerWitch(e)}>
							<FiChevronLeft />
						</button>
					</div>
					<nav className='navbar-nav'>
						<ul className='vertical menu no-print'>
							<li
								className={paginaActual === "/" ? "PaginaActual" : null}
								onClick={(e) => HandlerIdentificarPaginaActual(e)}
							>
							<Link to='/'>Inicio</Link>
						</li>
						{store.usuarioActual.tipo == "Administrador" ||
						store.usuarioActual.tipo == "Super Administrador" ||
						store.usuarioActual.tipo == "Vendedor" ||
						store.usuarioActual.tipo == "Contabilidad" ? (
							<li
								className={paginaActual === "/Ventas" ? "PaginaActual" : null}
								onClick={(e) => HandlerIdentificarPaginaActual(e)}
							>
								<Link to={"/Ventas/" + store.usuarioActual.nombre}>Ventas</Link>
							</li>
						) : null}
						<li
							className={
								paginaActual === "/GeneradorDocumentos" ? "PaginaActual" : null
							}
							onClick={(e) => HandlerIdentificarPaginaActual(e)}
						>
							<Link to='/GeneradorDocumentos'>Generador Docs</Link>
						</li>
						<li
							className={
								paginaActual === "/DireccionTributaria" ? "PaginaActual" : null
							}
							onClick={(e) => HandlerIdentificarPaginaActual(e)}
						>
							<Link to='/DireccionTributaria'>Dt Santiago</Link>
						</li>
						<li
							className={
								paginaActual === "/DtProvidencia" ? "PaginaActual" : null
							}
							onClick={(e) => HandlerIdentificarPaginaActual(e)}
						>
							<Link to='/DtProvidencia'>Dt Providencia</Link>
						</li>
						<li
							className={
								paginaActual === "/Patentes" ? "PaginaActual" : null
							}
							onClick={(e) => HandlerIdentificarPaginaActual(e)}
						>
							<Link to='/Patentes'>Patentes</Link>
						</li>
						<li
							className={
								paginaActual === "/Contabilidad" ? "PaginaActual" : null
							}
							onClick={(e) => HandlerIdentificarPaginaActual(e)}
						>
							<Link to='/Contabilidad'>Contabilidad</Link>
						</li>
						{store.usuarioActual.tipo == "Administrador" ||
						store.usuarioActual.tipo == "Super Administrador" ? (
							<li
								className={
									paginaActual === "/Administracion" ? "PaginaActual" : null
								}
								onClick={(e) => HandlerIdentificarPaginaActual(e)}
							>
								<Link to='/Administracion'>Adm Usuarios&#9812;</Link>
							</li>
						) : null}
						{store.usuarioActual.tipo == "Administrador" ||
						store.usuarioActual.tipo == "Super Administrador" ? (
							<li
								className={
									paginaActual === "/AdministracionVentas"
										? "PaginaActual"
										: null
								}
								onClick={(e) => HandlerIdentificarPaginaActual(e)}
							>
								<Link to='/AdministracionVentas'>Adm Ventas&#9814;</Link>
							</li>
						) : null}
						<li className='navbar-logout'>
							<Link to='#' onClick={(e) => HandlerCerrarSesion(e)}>
								Cerrar Sesion
							</Link>
						</li>
						</ul>
					</nav>
				</div>
			</div>
		);
	};

	const NavbarCortito = () => {
		return (
			<div className='NavbarCortito no-print'>
				<button className='btn-expand-navbar' onClick={(e) => HandlerWitch(e)} data-close>
					<FiChevronRight />
				</button>
			</div>
		);
	};

	return (
		<Fragment>
			{store.token == null && store.usuarioActual == null ? (
				<NavbarInicio />
			) : store.witch ? (
				<NavbarDesplegado />
			) : (
				<NavbarCortito />
			)}
		</Fragment>
	);
};

export default Navbar;
